import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import MyButton from "./MyButton";
import "../styles/contactMe.css";

const ContactMe = () => {
  const handleContact = () => {
    var yourMessage = document.getElementById("message").value;
    var subject = document.getElementById("subject").value;
    document.location.href =
      "mailto:lutfi.nurilanwar@gmail.com?subject=" +
      encodeURIComponent(subject) +
      "&body=" +
      encodeURIComponent(yourMessage);
  };
  return (
    <div className="section text-light" id="contact-me">
      <div id="contact-me" className="container">
        <Row className="row mt-4 align-items-center justify-content-between d-sm-flex flex-column-reverse flex-md-row">
          <Col className="col-11 col-md-6 mb-md-0 mb-5">
            <h1 id="title">
              Contact <span>me</span>
            </h1>
            <form
              className="mt-4"
              id="contact-form"
              name="contact-form"
              action="mail.php"
              method="POST"
            >
              <div className="row mb-2">
                <div className="col-md-6 mb-3">
                  <div className="md-form mb-0">
                    <input
                      placeholder="Your name"
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="col-md-6 mb-2">
                  <div className="md-form mb-0">
                    <input
                      placeholder="Your email"
                      type="text"
                      id="email"
                      name="email"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="md-form mb-4">
                    <input
                      placeholder="Subject"
                      type="text"
                      id="subject"
                      name="subject"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-12">
                  <div className="md-form">
                    <textarea
                      placeholder="Your Message"
                      type="text"
                      id="message"
                      name="message"
                      rows="2"
                      className="form-control md-textarea"
                    ></textarea>
                  </div>
                </div>
              </div>
            </form>

            <div className="mt-3">
              <a className="p-0" onClick={() => handleContact()}>
                <MyButton text={`Send Message`} />
              </a>
            </div>
          </Col>
          <Col className="text-center">
            <img
              className="w-75"
              src="https://i.ibb.co/FqSfryZ/Sent-Message-cuate.png"
              alt="Sent-Message-cuate"
              border="0"
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ContactMe;
